import React, {Component} from 'react'
import EkoModal from '../../components/elements/EkoModal'
import Util from '../../util/Util';

class ModalTransaction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: true,
            formData: {},
            saving: false,
            savingModal: false,
            errors: {},
            formFields: {},
            amount: 0,

        }
    }

    closeModal() {
        this.setState({saving: false,formData:{}});
        this.props.closeModal();
    }

    print() {
        var content = document.getElementById("print-section");
        var pri = window.open('', 'PRINT', 'height=800,width=800');

        pri.document.write('<html><head><title>Fatura Detayı</title>');
        
        pri.document.write('<base href="' + window.location.origin + window.location.pathname + '">');

        var styles = document.querySelectorAll('style, link[rel="stylesheet"]');
        for (var i = 0; i < styles.length; i++) {
             pri.document.write(styles[i].outerHTML);
        }

        pri.document.write('<style>@media print { body, html { visibility: visible !important; background: white !important; } * { visibility: visible !important; } .no-print { display: none !important; } }</style>');
        
        pri.document.write('</head><body>');
        
        var contentClone = content.cloneNode(true);
        var options = contentClone.getElementsByClassName("no-print");
        while (options.length > 0) {
            options[0].parentNode.removeChild(options[0]);
        }

        pri.document.write(contentClone.innerHTML);
        pri.document.write('</body></html>');

        pri.document.close(); 
        pri.focus(); 
        
        setTimeout(function() {
            pri.print();
            pri.close();
        }, 1000);
    }

    render() {
        let objects = this.props.fetchApi;
        let sales = this.props.salesApi;
        let kdv = 0;
        var doc_no = "";
        if(sales.legal_serial){
            doc_no = sales.legal_serial+""+sales.legal_no;
        }
        return (
            <EkoModal
                showModal={this.props.showModal}
                onHide={this.closeModal.bind(this)}
                spinner={this.state.savingModal}
                dialogClassName="transaction-modal"
                title={"Fatura Detayı"}
            >
                <div id="print-section">
                    <div className="row" style={{padding:"20px"}}>
                        <table style={{width: '100%'}}>
                            <tr>
                                <td><table style={{borderCollapse: 'collapse'}}>
                                <tbody>
                                <tr>
                                    <td style={{width: '20%'}}>Firma</td>
                                    <td>: <b>
                                        {sales?.customer?.firstname ?? sales?.supplier?.firstname ?? ""} 
                                        {" "}
                                        {sales?.customer?.lastname ?? sales?.supplier?.lastname ?? ""}
                                    </b></td>
                                </tr>
                                <tr>
                                    <td>Firma Adresi</td>
                                    <td>: <b>
                                        {sales?.customer?.customer_addresses?.[0]?.address ?? 
                                        sales?.supplier?.supplier_addresses?.[0]?.address ?? ""}
                                    </b></td>
                                </tr>
                                <tr>
                                    <td>VKN</td>
                                    <td>: <b>
                                        {sales?.customer?.tax_identity_number ?? 
                                        sales?.supplier?.tax_identity_number ?? ""}
                                    </b></td>
                                </tr>
                                {doc_no !== "" && (
                                    <tr>
                                        <td>Fatura No</td>
                                        <td className="td">: <b>{doc_no}</b></td>
                                    </tr>
                                )}
                                <tr>
                                    <td>Fatura Tarihi</td>
                                    <td className="td">: <b>{sales?.date??""}</b></td>
                                </tr>
                                {sales?.due_date != null && (
                                    <tr>
                                    <td>Vade Tarihi</td>
                                    <td className="td">: <b>{sales?.due_date??""}</b></td>
                                </tr>
                                )}
                                </tbody>
                            </table></td>
                            </tr>
                        </table>

                    </div>
                <table className="table"  style={{padding:"20px"}}>
                    <thead>
                        <tr className="transactionOptions">
                            <th style={{width: "12%"}}>Ürün / Hizmet</th>
                            <th style={{width: "30%"}}>Açıklama</th>
                            <th style={{width: "6%"}}>Miktar</th>
                            <th style={{width: "9%"}}>Birim Fyt</th>
                            <th style={{width: "10%"}}>Birim</th>
                            <th style={{width: "7%"}}>İsk. %</th>
                            <th style={{width: "7%"}}>İsk. Tutar</th>
                            <th style={{width: "8%"}}>KDV %</th>
                            <th style={{width: "9%"}}>KDV</th>
                            <th style={{width: "14%"}}>Toplam Tutar</th>
                        </tr>
                    </thead>

                    <tbody>

                        {Object.values(objects).map((item, i)=>{

                            if(item.vat_rate_type_id === 1)
                                kdv = "KDVsiz";
                            else if(item.vat_rate_type_id === 2)
                                kdv = "1%";
                            else if(item.vat_rate_type_id === 3)
                                kdv = "8%";
                            else if(item.vat_rate_type_id === 4)
                                kdv = "18%";
                            else if(item.vat_rate_type_id === 5)
                                kdv = "10%";
                            else {
                                kdv = "20%";
                            }
                            return(
                                <tr key={i} className="transactionOptions">
                                    <td>{item.item_code}</td>
                                    <td>{item.description}</td>
                                    <td>{Util.convertDecimalToMoney6(item.quantity)}</td>
                                    <td>{Util.convertDecimalToMoney5(item.unit_price_fc)}</td>
                                    <td>{item.unit_str}</td>
                                    <td>{item.discount_rate}</td>
                                    <td>{item.discount_amount_fc}</td>
                                    <td>{kdv}</td>
                                    <td>{Util.convertDecimalToMoney(item.vat_amount_fc)}</td>
                                    <td>{Util.convertDecimalToMoney(item.total_amount_fc)}</td>
                                </tr>
                            )
                            // <tr>
                            //     <td>{item.id}</td>
                            // </tr>
                        })} 
                       
                    </tbody>
                      
                </table>

                <div className="modalTotal"  style={{padding:"20px"}}>

                    <table className="tplus">

                        <tbody>

                            <tr>

                                <td>Tutar:</td>
                                <td>{Util.convertDecimalToMoney(sales.price_amount_fc)} {sales.currency === 'EUR' ? "€" : sales.currency === 'USD' ? "$" : sales.currency === 'GBP' ? "£" : sales.currency === 'CHF' ? "CHF" : "₺"}</td>

                            </tr>

                            <tr>

                                <td>İskonto:</td>
                                <td>{Util.convertDecimalToMoney(sales.discount_amount_fc)} {sales.currency === 'EUR' ? "€" : sales.currency === 'USD' ? "$" : sales.currency === 'GBP' ? "£" : sales.currency === 'CHF' ? "CHF" : "₺"}</td>

                            </tr>

                            <tr>

                                <td>Fatura Matrahı:</td>
                                <td>{Util.convertDecimalToMoney(sales.net_amount_fc)} {sales.currency === 'EUR' ? "€" : sales.currency === 'USD' ? "$" : sales.currency === 'GBP' ? "£" : sales.currency === 'CHF' ? "CHF" : "₺"}</td>

                            </tr>

                            <tr>

                                <td>KDV Toplamı:</td>
                                <td>{Util.convertDecimalToMoney(sales.vat_amount_fc)} {sales.currency === 'EUR' ? "€" : sales.currency === 'USD' ? "$" : sales.currency === 'GBP' ? "£" : sales.currency === 'CHF' ? "CHF" : "₺"}</td>

                            </tr>

                            <tr>

                                <td>Genel Toplam:</td>
                                <td>{Util.convertDecimalToMoney(sales.total_amount_fc)} {sales.currency === 'EUR' ? "€" : sales.currency === 'USD' ? "$" : sales.currency === 'GBP' ? "£" : sales.currency === 'CHF' ? "CHF" : "₺"}</td>

                            </tr>

                        </tbody>

                    </table>
                    <div className="no-print" style={{ textAlign: 'right', marginTop: '10px' }}>
                        <button className="btn btn-primary" onClick={this.print.bind(this)}>Yazdır</button>
                    </div>
                
                </div>
                </div>

            </EkoModal>
        )
    }
}

export default ModalTransaction;
